// extracted by mini-css-extract-plugin
export default {"item-selector":"item-selector_item-selector__OE34y"};